import React from 'react';

const Message = ({ error }) => {
    return (
        <div className="is-invalid text-center mb16">
            <div className="invalid-feedback">
                {Object.entries(error).map(([key, value]) => {
                    console.log(key, value);
                    return (<div key={key}>{value}</div>);
                })}
            </div>
        </div>
    );
};

export default Message;
